<template>
    <project-template>

        <project-video
        size="100"
        videoID="348075034" />

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectVideo from '../../components/project/ProjectVideo.vue'

export default {
  components: { ProjectTemplate, ProjectVideo }
}
</script>

<style lang="scss" scoped>

</style>
